//EXTERNAL
import React from "react";
import { Redirect } from "react-router-dom";
//COMPONENTS
//ASSETS
//FUNCTIONS
//CONTEXT
import { useUserState } from "../contexts/user.context";

export default function Lander() {
  const user = useUserState();

  return <>{user.isAuthenticated ? <Redirect to={`/library/${user.teamId}`} /> : <Redirect to={"/signin"} />}</>;
}
